import React, { useState } from "react";
import { Button } from "../Button";
import { useAddBranch } from "../../hooks/branchHooks/branch.hooks";
import { useDispatch } from "react-redux";
import {
  setErrorMessage,
  setSuccessMessage,
} from "../../Redux/Slices/alert.slice";
import { parseApiError } from "../../Helper/apiError.helper";
import { BranchForm } from "./BranchForm";
import { validateBranchData } from "../../Helper/validation/branchData.validation.helper";

export const AddBranch = () => {
  const dispatch = useDispatch();

  const [branchName, setBranchName] = useState("");
  const [branchAddress, setBrachAddress] = useState("");
  const [branchEstablished, setBranchEstablished] = useState("");
  const [branchDesc, setBranchDesc] = useState("");

  const { isLoading: isSavingBranch, mutate: addBranch } = useAddBranch({
    onSuccess: () => {
      dispatch(setSuccessMessage("Branch added successfully."));
      setBranchName("");
      setBrachAddress("");
      setBranchEstablished("");
      setBranchDesc("");
    },
    onError: (error: any) => {
      dispatch(setErrorMessage(parseApiError(error)));
    },
  });

  const handleAddBranch = () => {
    if (
      !validateBranchData(
        {
          branchName: branchName,
          branchAddress: branchAddress,
          branchEstablished: branchEstablished,
          branchDesc: branchDesc,
        },
        dispatch
      )
    ) {
      return;
    }

    addBranch({
      name: branchName,
      address: branchAddress,
      established_in: branchEstablished,
      description: branchDesc,
    });
  };

  return (
    <div>
      <div>
        <BranchForm
          branchName={branchName}
          setBranchName={setBranchName}
          branchAddress={branchAddress}
          setBrachAddress={setBrachAddress}
          branchEstablished={branchEstablished}
          setBranchEstablished={setBranchEstablished}
          branchDesc={branchDesc}
          setBranchDesc={setBranchDesc}
        />
      </div>
      <div>
        <Button
          loading={isSavingBranch}
          text="Save"
          onClick={handleAddBranch}
        />
      </div>
    </div>
  );
};
